import styled, { css } from 'styled-components';
import { customMedia, cssDropdown, cssDropdownItem } from 'styles/utils';

import Icon from 'components/Icon';

import { MOBILE_HEIGHT } from '../header.styled';

// This value in px is already the lowest size for mobile +/- 7-10 mm or 38-42 px. We are working with multiples of 8, 40px is a good fit to the minimum target touch size.
// https://www.bbc.co.uk/accessibility/forproducts/guides/mobile/target-touch-size
const MOBILE_TREE_HEIGHT = 40;

export const defaultRow = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100vw;
  min-height: ${MOBILE_HEIGHT}px;
  padding: 0 ${props => props.theme.spacing.default};
  border-bottom: ${props =>
    props.parent ? `1px solid ${props.theme.color.wfGrey200}` : 'none'};
  cursor: pointer;

  a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: ${MOBILE_HEIGHT}px;

    color: ${props => props.theme.color.wfBlack};
  }

  &:hover {
    background-color: ${props => props.theme.color.wfGrey100};
    color: ${props => props.theme.color.primary};

    a {
      color: ${props => props.theme.color.primary};
    }
  }
`;

export const IconCaretStyled = styled(Icon)`
  margin-left: ${props => props.theme.spacing.small};
  transform: scale(0.85)
    ${props => (props.show ? 'rotateX(180deg)' : 'rotateX(0deg)')};

  path {
    fill: ${props =>
      props.isDark
        ? props.theme.color.wfWhite
        : props.show
        ? props.theme.color.primary
        : props.theme.color.wfGrey800};
  }

  transition: transform ease-in-out 0.2s;
`;

export const Subnav = styled.ul`
  ${customMedia.greaterThan('large')`
    display: ${props => (props.show ? 'block' : 'none')};
    top: 90%;
    ${cssDropdown}
  `}
`;

export const NavItem = styled.li`
  ${customMedia.lessThan('large')`
    ${defaultRow}
    min-height: ${MOBILE_TREE_HEIGHT}px;
    font-weight: ${props => props.theme.font.weight.xbold};

    a {
      font-weight: ${props => props.theme.font.weight.xbold};
      min-height: ${MOBILE_TREE_HEIGHT}px;
    }
  `}

  ${customMedia.greaterThan('large')`
    position: relative;
    display: inline-flex;
    padding: 1rem;
    vertical-align: middle;
    align-items: center;
    a,
    div {
      display: block;
      color: ${props =>
        props.isActive || props.show
          ? props.theme.color.wfBlue
          : props.isDark
          ? props.theme.color.wfWhite
          : props.theme.color.wfBlack};
      font-size: 0.975rem;
      font-weight: ${props =>
        props.isActive
          ? props.theme.font.weight.xbold
          : props.theme.font.weight.regular};
      &:hover {
        color: ${props => props.theme.color.primary};
        text-decoration: none;
      }
    }
    div {
      cursor: default;
    }
    &:hover {
      > svg > path {
        color: ${props => props.theme.color.primary};
      }
    }
  `}
`;

export const SubnavItem = styled.li`
  ${customMedia.lessThan('large')`
    ${defaultRow}
    min-height: ${MOBILE_TREE_HEIGHT}px;
    padding: 0 ${props => props.theme.spacing.default} 0 ${props =>
    props.theme.spacing.large};
    font-weight: ${props => props.theme.font.weight.regular};

    a {
      min-height: ${MOBILE_TREE_HEIGHT}px;
      font-weight: ${props => props.theme.font.weight.regular};
    }
  `}

  ${customMedia.greaterThan('large')`
    a {
      ${cssDropdownItem}
      font-weight: ${props => props.theme.font.weight.regular};
    }
  `}
`;

export const IconStyled = styled(Icon)`
  vertical-align: top;
  margin-right: ${props => props.theme.spacing.small};

  path {
    stroke: ${props =>
      props.isDark ? props.theme.color.wfWhite : props.theme.color.wfBlack};
  }
`;

export const MainNavDesktopWrapper = styled.ul`
  display: block;
  margin-left: auto;
  margin-right: 1vw;

  ${props =>
    props.negativeVersion &&
    css`
      ${NavItem} {
        a,
        div {
          color: ${props.theme.color.wfWhite};
          &:hover {
            text-decoration: underline;
          }
        }
      }
      ${SubnavItem} {
        a {
          color: ${props.theme.color.wfBlack};
          &:hover {
            color: ${props.theme.color.wfWhite};
            text-decoration: none;
          }
        }
      }
    `}

  ${customMedia.lessThan('large')`
    display: none;
  `}
`;
